(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/game-list/assets/javascripts/game-list.js') >= 0) return;  svs.modules.push('/components/casino/game-list/assets/javascripts/game-list.js');
"use strict";


const {
  createFocusTrap
} = svs.components.lbUtils.focusTrap;
class GameList {
  constructor() {
    let gameList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let restoreSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let casinoSection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'casino';
    let categoryTitle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'sök';
    this.el = $('#casino-game-list');
    this.gameListGrid = $('#casino-game-list-grid');
    this.gameListCounter = $('#casino-game-list-counter');
    this.sortButton = this.el.find('button.js-casino-game-list-sort');
    this.sortExpanded = false;
    this.sortButtonLabel = this.el.find('#casino-sort-label');
    this.gameList = gameList;
    this.categoryTitle = categoryTitle;
    this.casinoSection = casinoSection;
    this.restoreSearch = restoreSearch;
    this.gameListGridTemplate = svs.casino.game_list.templates.game_list_grid;
    this.isPnp = svs.core.config.data.svsconfig.site === 'momang';
    this.focusTrap = createFocusTrap({
      refocus: true,
      ariaHiddenElements: ['#casino-game-list-grid', '#casino-game-list-counter', '.casino-categories'],
      selectors: ['li.js-casino-sort-option'],
      onEscape: () => {
        this.sortPopover.hide();
        this.focusTrap.releaseFocus(this.sortButton[0]);
      }
    });
    this.createObserver();
    this.initGamePromos();
    this.defaultGameList = this.gameList;
    this.addListeners();
    svs.components.casino.shared.restoreSearchState(searchState => {
      const {
        mode,
        label,
        direction
      } = restoreSearch ? searchState.sort : {
        mode: 'default',
        label: 'Sortera',
        direction: 'asc'
      };
      if (mode !== 'default') {
        this.sort({
          mode,
          label,
          direction
        });
      }
    });
  }
  showSortingDropMenu() {
    let listening;
    if (!this.sortPopover.visible()) {
      this.sortPopover.show();
      this.focusTrap.trapFocus(this.el.find('.casino-sort-options')[0]);
      if (!listening) {
        listening = true;
        const chooseOptions = e => {
          const sortOption = $(e.target);
          const [mode, direction] = sortOption.data('mode').split('-');
          this.sort({
            mode,
            label: sortOption.text(),
            direction
          });
          if (this.restoreSearch) {
            svs.casino.activeSearchFilters.sort = {
              mode,
              label: mode === 'default' ? 'Sortera' : sortOption.text(),
              direction: direction || 'asc'
            };
            svs.components.casino.shared.recordSearchState();
          }
          this.sortPopover.hide();
          this.focusTrap.releaseFocus(this.sortButton[0]);
        };
        this.sortPopover.obj.find('.js-casino-sort-option').on('click', e => chooseOptions(e));
        this.sortPopover.obj.find('.js-casino-sort-option').on('keydown', e => {
          if (e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            chooseOptions(e);
          }
        });
      }
    }
  }
  addListeners() {
    const casinoSection = this.casinoSection;
    const sortOptions = {
      position: this.isPnp ? 'bottom-left' : 'bottom-right',
      content: svs.casino.game_list.templates.sort({
        casinoSection
      }),
      closeOnOutsideClick: true,
      branding: 'popover-casino',
      offset: {
        top: 0,
        right: 12,
        left: this.isPnp ? undefined : 0
      },
      onShow: () => this.toggleSortAriaExpanded(),
      onHide: () => this.toggleSortAriaExpanded()
    };
    this.sortPopover = new svs.components.Popover(this.sortButton, sortOptions);
    this.sortButton.on('click', () => this.showSortingDropMenu(this.sortPopover));
    this.sortButton.on('keydown', e => {
      if (e.keyCode === 13) {
        this.showSortingDropMenu(this.sortPopover);
      }
    });
    this.navigateBackEl = document.querySelector('.casino-category-page .js-casino-game-info-hide');
    this.navigateBackEl && this.navigateBackEl.addEventListener('click', e => this.navigateBackEvent(e));
  }
  toggleSortAriaExpanded() {
    this.sortExpanded = !this.sortExpanded;
    this.sortButton[0].setAttribute('aria-expanded', this.sortExpanded);
  }
  updateNumberOfGames(numberOfGames) {
    this.gameListCounter.text("".concat(numberOfGames || '0', " spel"));
  }
  updateLabel(label) {
    this.sortButtonLabel.text(label);
  }
  navigateBackEvent(e) {
    e.preventDefault();
    svs.components.casino.router.back();
  }
  sort() {
    let sortOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      mode: 'default',
      label: 'Sortera',
      direction: 'asc'
    };
    this.gameList = [...this.defaultGameList];
    if (sortOptions.mode !== 'default') {
      const ascending = sortOptions.direction === 'asc';
      this.gameList.sort((gameA, gameB) => {
        gameA = gameA.rendered ? gameA.game.name : gameA;
        gameB = gameB.rendered ? gameB.game.name : gameB;
        const a = svs.components.casino.games[gameA][sortOptions.mode];
        const b = svs.components.casino.games[gameB][sortOptions.mode];
        return a < b ? -1 : a > b;
      });
      !ascending && this.gameList.reverse();
    }
    this.updateLabel(" ".concat(sortOptions.label));
    this.repaint();
  }
  repaint() {
    const grid = $(this.gameListGridTemplate({
      gameList: this.gameList,
      area: this.categoryTitle
    }));
    this.gameListGrid.replaceWith(grid);
    this.gameListGrid = grid;
    this.destroyPromos();
    this.initGamePromos();
  }
  setDefaultGameList(gameList) {
    this.defaultGameList = gameList;
    this.updateNumberOfGames(gameList.length);
  }
  initGamePromos() {
    this.gamePromoViews = {};
    this.gameList = [];
    this.el.find('.js-casino-game-promo').each((i, el) => {
      const gameName = $(el).data('name');
      this.gameList.push(gameName);
      this.gamePromoViews[gameName] = new svs.components.casino.game.PromoView(svs.components.casino.games[gameName], {
        observer: this.observer,
        initPosition: i,
        area: this.categoryTitle,
        showFavorite: true
      }, el);
    });
  }
  createObserver() {
    if (window.IntersectionObserver) {
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(e => {
          const gamePromoView = $(e.target).data('gamePromoView');
          if (e.isIntersecting === true || e.intersectionRatio > 0) {
            gamePromoView && gamePromoView.visible();
          } else {
            gamePromoView && gamePromoView.hidden();
          }
        });
      }, {
        rootMargin: '0px 0px 500px 0px'
      });
    }
  }
  destroyPromos() {
    for (const gameName of Object.keys(this.gamePromoViews)) {
      this.gamePromoViews[gameName].destroy();
    }
  }
  destroy() {
    this.sortButton.off('click');
    this.sortButton.off('keyup');
    this.destroyPromos();
    this.observer.disconnect();
    this.focusTrap.destroy();
  }
  show() {
    this.el.show();
  }
  hide() {
    this.el.hide();
  }
}
setGlobal('svs.components.casino.initGameList', renderModel => new GameList(renderModel));
setGlobal('svs.components.casino.GameList', GameList);
setGlobal('svs.components.casino.test.GameList', GameList);

 })(window);